import {classNames} from "shared/lib/classNames/classNames";
import Title from "shared/ui/Title/Title";
import cls from "./MainPage.module.scss";
import Paragraph, {ParagraphTheme} from "shared/ui/Paragraph/Paragraph";
import ArrowLink, {ArrowLinkTheme} from "shared/ui/ArrowLink/ArrowLink";
import Decor from "shared/assets/images/decor.png"

const MainPage = () => {

    return (
        <div id={"mainPage"} className={cls.indexPage}>
            <section
                className={classNames("page-section", {}, [cls.indexPage__about])}
            >
                    <div className={cls.About}>
                        <div className={cls.About__info}>
                            <Title className={cls.indexPage__title} sentences={["Hyperad Lab"]}/>
                            <Paragraph theme={ParagraphTheme.BRIGHT}>
                                Cutting-edge mobile software creators transforming concepts into intuitive, powerful apps. Our approach merges inventiveness with state-of-the-art tech to craft remarkable digital solutions that elevate user engagement.                            </Paragraph>
                            <ArrowLink color={"#0AF"} href={"#aboutPage"} className={cls.About__arrow}/>
                        </div>

                        <div className={cls.About__img}>
                            <img src={Decor} alt="decoration"/>
                        </div>
                    </div>
            </section>
        </div>
)
};

export default MainPage;
